import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

export interface WeatherDisplayModel {
  temp_c: number;
  temp_f: number;
  precip_mm: number;
  condition: { text: string; icon: string };
  wind_kph: number;
  humidity: number;
}

@Injectable({
  providedIn: 'root',
})
export class WeatherForecastService {
  #httpClient = inject(HttpClient);
  readonly #weatherURL: string = 'https://api.weatherapi.com/v1';
  readonly #apiKey: string = 'c434cd422eea418daff181447240711';

  /**
   * bulk request are paid, stopped to work
   * @param payload
   */
  getWeatherByCountries(payload: { locations: any[] }): Observable<any> {
    return this.#httpClient.post(
      `${this.#weatherURL}/current.json?q=bulk&key=${this.#apiKey}`,
      payload,
    );
  }

  getWeatherByCity(cityName: string): Observable<WeatherDisplayModel> {
    return this.#httpClient
      .get<{
        current: WeatherDisplayModel;
      }>(`${this.#weatherURL}/current.json?q=${cityName}&key=${this.#apiKey}`)
      .pipe(map((i) => i.current));
  }
}
